import type { AsyncStatus } from 'lib-shared-legacy-types';
import { Action, handleActions } from 'redux-actions';


import type { FlowChatActionT, FlowChatGetFlowResponseT } from '../api/types';

import { chatFlowGetSucceeded } from './chatFlow';

export type ChatFlowNodeStateT = {
  meta: {
    asyncStatus: AsyncStatus;
  };
  nodes?: null | Record<string, FlowChatActionT>;
};

type FlowChatNodeHandleActionPayloadT = FlowChatGetFlowResponseT;

// Init state for the Chat Nodes.
const initialState: ChatFlowNodeStateT = {
  meta: {
    asyncStatus: 'succeeded',
  },
  nodes: null,
};

// Reducer
const chatNodes = handleActions<
  ChatFlowNodeStateT,
  FlowChatNodeHandleActionPayloadT
>(
  {
    [chatFlowGetSucceeded.toString()]: (
      state: ChatFlowNodeStateT,
      action: Action<FlowChatGetFlowResponseT>,
    ): ChatFlowNodeStateT => {
      const nodes = {};
      if (
        action.payload?.data?.actions &&
        Array.isArray(action.payload.data.actions)
      ) {
        for (const node of action.payload.data.actions) {
          nodes[node.id] = node;
        }

        return { ...state, nodes };
      }

      return state;
    },
  },
  initialState,
);

export default chatNodes;
